module.exports = __webpack_public_path__ + "img/map_es.9fc67c7.png";